// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__2LWfx","content":"LayoutSettings_content__3wUVC"};